import 'moment/locale/en-gb.js';
import { ITranslationForMts } from './translationInterface';

export const enGbForMts: ITranslationForMts = {

    route_PrematchHome: 'lv',
    route_TopBetsMobile: 'top',
    route_HomeTopBetsDesktop: 'most-popular',
    route_HomeLiveDesktop: 'live',
    route_HomeHotBetsDesktop: 'hotbets',
    route_HomeTicketOfDayDesktop: 'bet-of-the-day',
    route_HomeTopOfferDesktop: 'top-offer',
    route_SportsList: 'sports',
    route_StandardEvents: 'events',
    route_StandardEventDetail: 'event',
    route_LiveEvents: 'live-events',
    route_LiveEventDetail: 'live-event',
    route_CashOut: 'cashout',
    route_BetDetail: 'my-betslip',
    route_BetDetailPublic: 'betslip',
    route_LegacyTicketDetailPublic: "betslipl",
    route_BetList: 'my-betslips',
    route_BetListVG: 'my-betslips-vg',
    route_BetWinList: 'my-wins',
    route_Search: 'search',
    route_MarketingAction: 'competitions',
    route_TicketDetail: 'my-betslip',
    route_TicketDetailVG: 'my-betslip-vg',
    route_TicketDetailByNumber: 'find-betslip',
    route_Calendar: 'calendar',
    route_Favorites: 'favorites',
    route_Top5Bets: '',
    route_Top10Bets: '',
    //
    no_categories: 'No categories.',
    today: 'Today',
    tomorrow: 'Tomorrow',
    yesterday: 'Yesterday',
    weekend: 'Weekend',
    todayTomorrow: 'Today, Tomorrow ',
    by_date: 'By date',
    by_time: 'By time',
    by_week_day: 'By week day',
    hour: 'hour',
    three_hours: '3 hours',
    hours: 'hours',
    more: 'More',
    available_tips: 'Selections',
    date: 'Date',
    game: 'Game',
    deposit: 'Deposit:',
    eventual_winnings: 'Eventual winnings:',
    detail: 'Details',
    other: 'Other',
    less: 'Less',
    all: 'All',
    result: 'Result',
    statistics: 'Statistics',
    search: 'Search …',
    no_results: 'No results',
    detail_not_found: 'Details not found',
    back: 'Back',
    next: "Next",
    final_rate: 'Final odds:',
    finished: 'Finished',
    match: 'Match',
    bet: 'Bet',
    rate: 'Odds Rate',
    ticket_code: 'Betslip code',
    state: 'State',
    date_paid: 'Date paid',
    stake: 'Stake',
    eventual_win: 'Eventual win',
    ticket_type: 'Betslip type',
    bet_type: 'Bet type',
    channel: 'Channel',
    ticket_detail: 'Betslip detail',
    prize_paid: 'Final winnings',
    win_paid: 'To be paid',
    ticket_public_link: 'Betslip public link:',
    refresh: 'Refresh',
    download_file: 'Download file',
    combination: 'combination',
    combinations_0: 'combinations',
    combinations_few: 'combinations',
    combinations_more: 'combinations',
    combination_short: 'comb.',
    event_no_longer_available: 'Event is no longer active.',
    has_to_be_logged_in: 'Log in for category selection.',
    something_went_wrong: 'Something went wrong.',
    no_events_for_filter: "No events for applied filter.",
    no_events_or_leagues_found: "No events or leagues were found for applied filter.",
    search_searchEventTitle: "Search",
    flag_new: "new",

    bet_CancelUntil: 'Cancel possible until:',

    // --------------------- general
    general_BtnMore: "More",
    general_Loading: 'Loading...',
    general_OddsDraw: "Draw",
    general_EventGameGroupOther: "Other",
    general_EventLiveTag: "LIVE",
    general_CriticalRenderError: 'Error on page.',
    general_CriticalRenderRefreshBtn: 'Continue',
    general_CriticalRenderHomeBtn: 'Home page',
    general_ProgressContentError: 'Loading error, please try again.',
    general_ErrorInInitialization: 'Initialization error',
    general_SessionExpired: 'Session Expired',

    // ---------------------- menu
    menu_Top: "Top",
    menu_Prematch: "Pre-match",
    menu_Live: "LIVE",
    menu_Cashout: "CASHOUT",
    menu_Search: "Search",
    menu_Time: 'Time',

    // --------------------- live-menu
    liveMenu_overview: "Overview",
    liveMenu_favourites: "Favourites",
    liveMenu_event: "Event",
    liveMenu_calendar: "Calendar",

    //------------------- topBets
    topbets_TopBetsTitle: "Most popular",
    topbets_HotBetsTitle: "Hot bets",
    topbets_NoResults: "List is empty",
    topbets_Top5Title: "TOP 5",
    topbets_Top10Title: "TOP 10",

    //  ---------------------- prematch
    prematch_NoEventsForFilter: "There are no events for applied filter.",
    prematch_SportListTitle: "SPORT LIST",
    prematch_SportListNoSport: "There are no events for applied time interval.",
    prematch_TimeFilterAll: "All",
    prematch_TimeFilterToday: "Today",
    prematch_TimeFilterTodayTomorrow: "Today,Tomorrow",
    prematch_TimeFilterWeek: "Week",
    prematch_TabOdds: "Odds",
    prematch_TabStats: "Stats",
    prematch_EventNotExists: "Event is no longer available.",
    prematch_EventListSectionTop: "TOP",
    prematch_EventListSectionOthers: "Others",
    prematch_EventAvailableAsLive: "Event has already started, go to LIVE.",

    prematch_MobileExpandMoreVMT: "+ More",
    prematch_MobileCollapseMoreVMT: "- Less",

    // --------------------- live offer
    live_noRates: "Odds are not available at the moment.",
    live_seeOddsInDetail: "Click here and open market offer",
    live_EventHasEnded: "Event has already ended.",
    live_OtherEventsBtn: "Other events",
    live_TabOdds: "Odds",
    live_TabMatchTracker: "Match Tracker",
    live_TabMatchTrackerStats: "Statistics",
    live_TabVideo: "Video",
    live_NoEvents: "No active events.",
    live_BaseballCurrentHalfInningStat: "Current Half-Inning statistics",
    live_AmFootballAttackTeamStat: "Attacking team statistics",
    live_TimelineTitle: "MATCH TIME-LINE",
    live_TimelineDesktopTitle: "Events in Match",
    live_ScoreMainScoreTitle: "Score",
    live_OddBelowName: "Below",
    live_Favorites: "Favorites",
    live_NoFavorites: "No Favorites selected.",

    live_WarrantyInfo: "The given time and statistical information are only guide values. SIA Joker Ltd brand SynotTip does not guarantee how accurate or up-to-date is the information shown (e.g. current scores). This information cannot be used as the basis for any possible complaint.",

    // ------------------------------ desktop live
    desktopLive_OpenEvents: "Open events",
    desktopLive_FavoriteEvents: "Favorites",
    desktopLive_NoFavoriteEvents: "No Favorites selected. You can select the events by clicking on a star in left collum or on home page.",

    //--------------------- coupon

    coupon_commonError: "Coupon contains erroneous selections.",

    coupon_LoginForSend: "Log in for bet placement",
    coupon_UpdatingSystem: "refreshing ...",
    coupon_CouponGeneralError: "General error",
    coupon_CouponExpectedNotSystemError: "Internal system error, remove the selections and try again",
    coupon_CopyGeneralError: "Betslip copy error",
    coupon_StakeInputError: "Stake amount is not valid",
    coupon_TicketListCombination: "COMBINATION",
    coupon_TicketListStake: "STAKE",
    coupon_TicketListRate: "ODDS",
    coupon_TicketListPotentialWin: "EVENTUAL WINNINGS",
    coupon_SystemSwitchLabel: "SYSTEM",

    coupon_HeaderSystemCouponSetting: "System bet settings",
    coupon_StakeTypeCoupon: "COUPON",
    coupon_StakeTypeSystem: "SYSTEM",

    coupon_SummaryPricePotential: "Eventual winnings",
    coupon_Stake: "Stake",
    coupon_MaxStake: "Max. stake",
    coupon_TotalRate: "Total Rate",
    coupon_StakeForOneTicketInSystem: "Stake for one bet in system",
    coupon_AverageRate: "Average rate",

    coupon_SentSuccessMessage: "Your bet has been placed.Thank you.",
    coupon_SentRejectMessage: "Your bet has been rejected",
    coupon_CopyTicket: "Copy the betslip",
    coupon_NewTicket: "New betslip",

    coupon_evaluateBtn: "Recalculate",
    coupon_acceptRateChangeBtn: "Accept",
    coupon_sendToPay: "Submit",

    coupon_liveAcceptHigerRate: "Accept higher odds",
    coupon_liveAcceptAllRates: "Accept any odds",
    coupon_liveHint_Question: "Recommended stake amount for your bet is {value}. Do you agree?",
    coupon_liveHint_Yes: "Yes",
    coupon_liveHint_No: "No",

    coupon_TypePrematch: "Pre-match",
    coupon_TypeLive: "Live",

    coupon_OddTitle: "Bet",
    coupon_AddPublicLinkToChat: "", //not used

    // -------------------- ticket
    ticket_TicketTabLabel: "Betslip",
    ticket_BettingTicket: "Betslip",
    ticket_SelectionCount: "Number of predictions",
    ticket_StakeTypeAll: "COUPON",
    ticket_StakeTypeUnit: "KOMBI",
    ticket_StakeTypeTotal: "SYSTEM",
    ticket_OddTitle: "Bet",
    ticket_BankerTitle: "Banker",
    ticket_HasErrors: "Betslip contains errors",
    ticket_TicketTypeSimple: "Simple", //--Simple
    ticket_TicketTypeSystem: "System",  //--System
    ticket_TicketTypeVGSplit: "-",
    ticket_TicketTypeVGCombi: "-",
    ticket_EvalTypeLost: "Lost",
    ticket_EvalTypeWin: "Won",
    ticket_EvalTypeCancelledWithMP: "Cancelled",
    ticket_EvalTypeCancelled: "Cancelled",
    ticket_EvalTypeCashout: "Sold",
    ticket_NoTips: "Your betslip contains no predictions.",
    ticket_Ticket: 'Betslip',
    ticket_TicketStateSettled: "Evaluated",
    ticket_TicketStateStorno: "Cancelled",
    ticket_TicketStateStornoBySystem: "Cancelled",
    ticket_TicketStateStornoByMts: "Cancelled",
    ticket_TicketStateCommonAccepting: "Processing",
    ticket_TicketStateCommonAccepted: "Accepted",
    ticket_Login: "Log in to see the betslip.",
    ticket_Calculations: "Combinations list",
    ticket_NotFound: "Betslip not found",
    ticket_TicketOfNumberNotFound: "Betslip {number} not found",
    ticket_Group: "Group",
    ticket_CashoutTab: "Cashout",
    ticket_PrepareTicket: "Prepare",
    ticket_SelectionResult: "Result",

    ticket_ReuseOddsTicketBtn: "Copy to new betslip",
    ticket_ReuseOddsGeneralError: "Failed to add selections to the betslip, please try again.",
    ticket_ReuseOddsNotAllAddedError: "Some selections could not be added to the betslip because they are no longer active.",

    //my-tickets
    myTickets_NoTicket: 'No betslips',
    myTickets_Login: "Log in to see the betslips.",
    myTickets_ColumnPotentialPrice: 'Ev.win',
    myTickets_TypeSports: "SB",
    myTickets_TypeVirtualGames: "VG",

    //Mobile App advert
    mobileAppAdvert_title: "Mobile Sports apps",

    // ---------------------- bet detail
    bet_TicketIdTitle: "Betslip id",
    bet_TicketStateTitle: "State",
    bet_TicketReasonTitle: "Reason",
    bet_TicketDatePaid: "Date paid",
    bet_System: "System",
    bet_Stake: "Stake",
    bet_TotalRate: "Total rate",
    bet_PotentialPrice: "Eventual winnings",
    bet_FinalWin: "Final winnings",
    bet_ToPayout: "To be paid",
    bet_TicketType: "Betslip type",
    bet_BetType: "Bet type",
    bet_CanBeCancelledUntil: "Betslip can be cancelled until:",
    bet_Channel: "Channel",
    bet_Match: "Match",
    bet_Tip: "Selection",
    bet_TipWinTip: "Selection / Win Selection",
    bet_TipTicketDetail: "Selection",
    bet_Sum: "Sum", // kde sa používa?
    bet_PossibleWinFrom: "Possible winnings from",
    bet_PossibleWinTo: "Possible winnings to",
    bet_Errors: 'Errors',
    bet_HandlingFee: "Handling fee",
    bet_ProductFee: "Product fee",
    bet_ProductName: "Product",
    bet_OddsRateAdvantage: "Advanced rate",
    bet_RateAdvantageFactor: "Rate advantage",
    bet_Header: "Betslip detail",
    bet_SuccessfulCashout: "Cashout has been requested successfully",
    bet_ErrorDuringCashout: "Unable to request cashout",
    bet_ReallyCashoutBetOfValue: "Do you really want to request cashout for {value} ?",
    bet_FreeTicketSection: "Free ticket",

    bet_PublicLink: "Betslip public link",
    bet_TransferToCredit: "Transfer to credit",
    bet_TransferToBank: "Transfer to bank",

    bet_CopyConfirmYes: "Yes",
    bet_CopyConfirmNo: "No",
    bet_CopyConfirmQuestion: "In order to place the bet with lower stake is necessary to rewrite actual betslip. Do you agree?",
    bet_CopyConfirmTitle: "BETSLIP",

    bet_AgreeWithLowerAmount: "Do you agree with lower amount?",
    bet_Cashout: "Cashout",
    bet_ErrorInTicketListLoad: "Ticket list loading error",

    bet_CancelSuccess: 'Ticket has been cancelled.',
    bet_CancelError_AlreadyCancelled: 'Ticket has been already cancelled',
    bet_CancelError_PeriodOver: 'Time limit for cancellation has passed.',
    bet_CancelError_NotForThisPlayer: 'Ticket is for another player.',
    bet_CancelError_GeneralError: 'Cancellation error',
    bet_CancelBetBtnCancelTitle: "Cancel",

    coupon_CashoutAcceptHigerRate: "Accept higher amount",
    coupon_CashoutAcceptAllRates: "Accept any amount",
    coupon_cashoutButton: "Cashout for {value}",


    // ---------------- cashoutList
    cashoutList_ColumnTime: "time",
    cashoutList_ColumnStake: "stake",
    cashoutList_ColumnPotentialPrice: "Winnings",
    cashoutList_ColumnSell: "Cashout",
    cashoutList_NoTickets: "No tickets available for Cashout.",
    cashoutList_Login: "Log in to see tickets available for Cashout.",
    cashoutList_LoadAgain: "Reload",

    //--------------------- betList
    betList_TicketNumber: 'Betslip number',
    betList_ColumnTime: "Date",
    betList_ColumnStake: "Stake",
    betList_ColumnPotentialPrice: "Ev.win",
    betList_ColumnPricePotentialPrice: "Ev.win/win",
    betList_ColumnStatus: "Status",
    betList_ColumnDetail: "Detail",

    //--------------------- ticketList
    ticketList_TimeFilter_None: "all",
    ticketList_TimeFilter_Day: "Day",
    ticketList_TimeFilter_ThreeDays: "Three days",
    ticketList_TimeFilter_Week: "Week",
    ticketList_TimeFilter_TwoWeeks: "2 weeks",
    ticketList_TimeFilter_Month: "Month",

    ticketList_StateFilter_None: "all",
    ticketList_StateFilter_Accepted: "Accepted",
    ticketList_StateFilter_Win: "Won",
    ticketList_StateFilter_Loss: "Lost",
    ticketList_StateFilter_CancelWithHandlingFee: "Cancelled",
    ticketList_StateFilter_Cashout: "Accepted",
    ticketList_StateFilter_Storno: "Cancelled",

    ticketList_OfferTypeFilter_None: "all",
    ticketList_OfferTypeFilter_Prematch: "Pre-match",
    ticketList_OfferTypeFilter_Live: "Live",

    ticketList_Title: "Ticket list",
    ticketList_TimeFilterTitle: "Time interval",
    ticketList_StateFilterTitle: "State",
    ticketList_OfferTypeFilterTitle: "Bet type",
    ticketList_FilterSubmit: "Display",

    // ------------- ticket detail
    bet_FinalScoreInfo: "If match ends after overtime or penalty series, it will be displayed included in shown final result.",

    //-------------------- search
    search_FillSomethingInfo: "Enter the name of the event or league.",
    search_LastSearch: "Last search:",
    search_ResultEvents: "Events",
    search_ResultLeagues: "Leagues",
    search_NothingFound: "No event or league was found.",
    search_InProgress: "Searching ...",

    // ----------------- offline
    offline_InfoText: "Server or network connection interupted",
    offline_TryReconnect: "Try to reconnect",

    // ------------ recommended
    recommended_title: "Recommended",

    // ----------- mobile QR code
    mobileAppLinkAdvert_Header: "Mobile application",

    // ----------- marketing action
    marketingAction_NoAction: "No action found",
    marketingAction_Next: "Next",
    marketingAction_Less: "Less",

    //--------- live stream / matchtracker
    liveStream_Opening: "Opening ...",
    liveStream_ErrorOpening: "Error in loading the video.",
    liveStream_NeedToLogin: "Log in to watch the Live Stream.",
    liveStream_NeedLiveStreamAccess: "Please, finish registration to watch the Live Stream.",
    liveStream_NotPlayedNow: "Live Stream is not yet available. Starting at %1.",
    liveStream_NotAvailableFormat: "Unable to load the video. Starting at %1.",
    liveStream_TryAgain: "Try again",
    liveStream_NoVideoForThisPart: "Unable to load the video.",
    livestream_Login: "Login",

    // -------- live notifications
    liveNotification_ErrorOnUpdate: "Update error",
    liveNotification_Header: "Live notifications",
    liveNotification_AllowRequestText: 'Enable notifications in your device settings.',
    liveNotification_AllowRequestButton: 'Allow',
    liveNotification_NeedAllowInBrowserPermissions: "To receive messages about the match, you need to enable notifications in your browser.",

    //right column
    rightColumn_MyBetsToday: "MY BETS TODAY",
    rightColumn_NoBetsToday: "You have no bets today",
    rightColumn_LoadAgain: "Reload",

    //find ticket by number
    findTicketByNumber_title: "TICKET CHECK",
    findTicketByNumber_InfoText: "Enter the ticket number above the barcode:",
    findTicketByNumber_buttonSend: "Check",
    findTicketByNumber_Placeholder: "Betslip number",

    //chat
    chat_WriteMessagePlaceholder: "your message...",  //chat.yourMessage
    chat_SendMessage: "Send", //chat.sendMessage
    chat_Sending: "Sending ...", //chat.sendingText
    chat_LoginToSendMessage: "Log in to send message...",  //chat.loginToSendMessageInfo
    chat_LoadingMessages: "loading messages ...",
    chat_ErrorLoadingMessagesAgainBtn: "again",  //chat.btnErrorLoadingMessagesAgain
    chat_ErrorLoadingMessage: "unable to load the mesages",  //chat.errorLoadingMessages
    chat_PrivateReply: "Private reply",//chat.privateReply     // cjuba "Uživatelé mi můžou psát privátně",  //chat.acceptAllUsers
    chat_PublicReply: "Public reply",  //chat.publicReply
    chat_AcceptAllUsers: "Accept all users",  //chat.acceptAllUsers
    chat_BlockAllUsers: "Block all users",  //chat.blockAllUsers
    chat_BlockedUser: "Blocked user", //chat.blockedUser
    chat_NonblockedUser: "User not blocked",
    chat_NeedNickname: "Your nickname is not entered. Chat will be available to you after choosing a Nickname in your account settings",
    chat_AnswerForTitle: "Answer for",
    chat_ChatSendMessage_Success: "Message was sent",  //chat.sendMsgOk
    chat_ChatSendMessage_NonExistentReply: "Message on which you are replying is not available",  //chat.sendMsgNoSourceMsg
    chat_ChatSendMessage_PrivateBlocked: "User has blocked private messages",  //chat.sendMsgBlockedPrivate
    chat_ChatSendMessage_TimeConstraintFailed: "You need to wait %1 seconds before sending another message", //chat.sendMsgProtection
    chat_ChatSendMessage_UserBanned: "User is banned",  //chat.sendMsgBanned
    chat_ChatSendMessage_UserNotLogged: "You are not logged in",  //chat.sendMsgNotLogged
    chat_ChatSendMessage_Fail: "Unable to send message",  //chat.sendMsgError

    //saved ticket  // netreba prekladat do SK a CZ, pouziva sa iba v LV
    savedTicket_header: 'Notice',
    savedTicket_thanks: 'Your bet has been saved. Thank you.',
    savedTicket_p1: 'You can place your bet at any our betting shops using the number',
    savedTicket_p2: 'Bets cannot be placed once the taking of bets for the given prediction has closed, or after',
    savedTicket_warning: 'Place your bets as soon as you can! The odds in the offer frequently change and bets can be rejected because of a change in the odds.',
    savedTicket_identicalBet: 'Identical bet',

    //calendar
    calendar_startTime: 'start time',
    calendar_event: 'event',
    calendar_category: 'category',

    //upcoming events
    upcomingEvents_label: 'upcoming events',

    //favorites
    my_favorites: "Favourites",

    //live Favorites
    liveFavorites_showMoreDetails: "Show more",
    liveFavorites_hideMoreDetails: 'Show less',


    //OTB
    otb_Switch: 'One tap bet',
    otb_InfoText: 'After setting the one tap bet function, your bets will be sent directly after one click on the odds in the offer.',
    otb_InfoWarning: "Please confirm settings to activate One tap bet.",
    otb_SettingHeader: "Settings of One tap bet:",
    otb_FirstPage_Cancel: "Cancel",
    otb_FirstPage_Confirm: "Confirm",
    otb_TurnOffOTB: "Turn off One tap bet",
    otb_CancelBetslip: "Cancel betslip",
    otb_Sending: "Submitting",

    // rate filter
    rateFilter_Title: "Rate",
    rateFilter_From: "From",
    rateFilter_To: "To"
};

